// Mocked action to get available payment gateways
// TODO: Replace with actual API call when backend is ready

export interface PaymentGateway {
  id: string;
  name: string;
  displayName: string;
  description: string;
  iconColor: string;
  iconName: string;
}

export const getAvailablePaymentGateways = async (): Promise<PaymentGateway[]> => {
  // Simulate API delay
  await new Promise((resolve) => setTimeout(resolve, 100));

  // Mocked response - returns both Stripe and PayPal
  return [
    {
      id: "stripe",
      name: "Stripe Connect",
      displayName: "Stripe",
      description: "Instant payout enabled",
      iconColor: "#635BFF",
      iconName: "payments",
    },
    {
      id: "paypal",
      name: "PayPal Platform",
      displayName: "PayPal",
      description: "Connected to business acct",
      iconColor: "#003087",
      iconName: "account_balance_wallet",
    },
  ];
};
